import * as React from 'react';
import styled from 'styled-components';
import { ResponsiveTypography } from '../../../Typography/v3/ResponsiveTypography';
import SpeedButtonIcon from './SpeedButtonIcon';
import { DolPopover } from '../../../Popover/DolPopover';
import { colorsV2 } from '../../../colors-v2';
import cl from 'classnames';
import { observer } from 'mobx-react-lite';

const Main = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  position: relative;
  .speed {
    position: absolute;
  }
  cursor: pointer;
  margin-left: 9px;
`;
const DropDownMain = styled.div`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(3, max-content);
  gap: 8px;
  justify-content: center;
  align-items: center;
  padding: 6px;
  width: 140px;
  height: 40px;
  background: ${colorsV2.white100};
  border: 1px solid ${colorsV2.gray20};
  border-radius: 8px;
  .btn-speed {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
    width: 36px;
    height: 24px;
    border-radius: 8px;
    cursor: pointer;
    &.active {
      background: ${colorsV2.gray20};
    }
    &:hover {
      background: ${colorsV2.gray10};
    }
  }
`;

export const ChangeAudioSpeedComponent = observer(({ updatePlaybackSpeed, playbackRate }: any) => {
  const [visible, setVisible] = React.useState(false);
  return (
    <DolPopover
      overlayClassName="no-arrow dol-popover"
      visible={visible}
      onVisibleChange={setVisible}
      content={
        <DropDownMain>
          {[0.5, 0.75, 1].map((speed) => (
            <div
              key={speed}
              className={cl('btn-speed', { active: playbackRate === speed })}
              onClick={() => {
                updatePlaybackSpeed(speed);
                setVisible(false);
              }}
            >
              <ResponsiveTypography.Paragraph variant="semi-bold/11px | 8" color="black100">
                {`${speed}x`}
              </ResponsiveTypography.Paragraph>
            </div>
          ))}
        </DropDownMain>
      }
      trigger="click"
    >
      <Main>
        <SpeedButtonIcon />
        <ResponsiveTypography.Paragraph
          className="speed"
          variant="semi-bold/11px | 8"
          color="black100"
        >
          {`${playbackRate}x`}
        </ResponsiveTypography.Paragraph>
      </Main>
    </DolPopover>
  );
});
